import _classCallCheck from "/home/gonzalo/wfdev/webfarming-app-client/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/home/gonzalo/wfdev/webfarming-app-client/node_modules/@babel/runtime/helpers/esm/createClass";
import Coordinate from '../geom/Coordinate';
import SegmentPointComparator from './SegmentPointComparator';
import Comparable from '../../../../java/lang/Comparable';
var SegmentNode = /*#__PURE__*/function () {
  function SegmentNode() {
    _classCallCheck(this, SegmentNode);
    SegmentNode.constructor_.apply(this, arguments);
  }
  _createClass(SegmentNode, [{
    key: "getCoordinate",
    value: function getCoordinate() {
      return this.coord;
    }
  }, {
    key: "print",
    value: function print(out) {
      out.print(this.coord);
      out.print(' seg # = ' + this.segmentIndex);
    }
  }, {
    key: "compareTo",
    value: function compareTo(obj) {
      var other = obj;
      if (this.segmentIndex < other.segmentIndex) return -1;
      if (this.segmentIndex > other.segmentIndex) return 1;
      if (this.coord.equals2D(other.coord)) return 0;
      if (!this._isInterior) return -1;
      if (!other._isInterior) return 1;
      return SegmentPointComparator.compare(this._segmentOctant, this.coord, other.coord);
    }
  }, {
    key: "isEndPoint",
    value: function isEndPoint(maxSegmentIndex) {
      if (this.segmentIndex === 0 && !this._isInterior) return true;
      if (this.segmentIndex === maxSegmentIndex) return true;
      return false;
    }
  }, {
    key: "toString",
    value: function toString() {
      return this.segmentIndex + ':' + this.coord.toString();
    }
  }, {
    key: "isInterior",
    value: function isInterior() {
      return this._isInterior;
    }
  }, {
    key: "interfaces_",
    get: function get() {
      return [Comparable];
    }
  }], [{
    key: "constructor_",
    value: function constructor_() {
      this._segString = null;
      this.coord = null;
      this.segmentIndex = null;
      this._segmentOctant = null;
      this._isInterior = null;
      var segString = arguments[0],
        coord = arguments[1],
        segmentIndex = arguments[2],
        segmentOctant = arguments[3];
      this._segString = segString;
      this.coord = new Coordinate(coord);
      this.segmentIndex = segmentIndex;
      this._segmentOctant = segmentOctant;
      this._isInterior = !coord.equals2D(segString.getCoordinate(segmentIndex));
    }
  }]);
  return SegmentNode;
}();
export { SegmentNode as default };